module.exports = __webpack_public_path__ + "static/media/S4N1-4.5ff2ff91.svg";